export default __webpack_public_path__ + "static/typography-image-b-f3195751e0e2589daf09cb67988fe6ee2246de8cbb062fd332a39f60a5448d9a.png";